$( function() {
    $( ".contactModalForm .form-dropdown-group > select" ).selectmenu({
        appendTo: ".form-dropdown-group"
    });
    $( ".form-dropdown-group > select" ).selectmenu({
      create: function() {

        const selectMenuId = "ui-selectmenu-" + $(this).attr("id");

        $("#" + $(this).attr("id") + "-button").wrap(`<div id=${selectMenuId} style="width: fit-content; position: relative;"></div>`);

        const selectorSelectMenuId = "#" + selectMenuId;

        $("#" + $(this).attr("id") + "-menu").parent().attr("id", $(this).attr("id") + "-wrapper")

        $("#" + $(this).attr("id") + "-menu").css('max-height', '350px')

        $("#" + $(this).attr("id") + "-wrapper").detach().appendTo($(selectorSelectMenuId)).attr("style", "z-index: 1 !important");
      },
      change: function(){
        if($(this).attr("required")){
          let formField = $(this).closest('.form-field');
          let errorMessageMissing = formField.find('.error-message--missing');
          let errorMessageInvalid = formField.find('.error-message--invalid');
          formField.removeClass('error');
          if (errorMessageMissing) errorMessageMissing.removeClass('active');
          if (errorMessageInvalid) errorMessageInvalid.removeClass('active');
        }
      }
    });
});
